export const DEFAULT_LAYER_TIMEOUT_MS = 1000 * 60 * 30; // 30 minutes
export const ADSB_FETCH_INTERVAL_MS = 1000 * 60; // 1 minute
export const AIRCRAFT_LOCATION_REFRESH_INTERVAL_MS = 1000; // 1 second
export const AIRCRAFT_TRACE_REFRESH_INTERVAL_MS = 4000;
export const AIRCRAFT_CACHE_NO_DATA_EXPIRY_MS = 1000 * 60; // 60 seconds
export const TRACE_SOURCE_ID = 'aircraft-trace-source';
export const TRACE_LAYER_ID = 'aircraft-trace-layer';
